import { BrightyFilters, BrightyMessagesResponseDTO, FindBrightyChatByIdDTO, getAllTitlesResponseDTO, UserMessage } from "./dto";
import { BrightyServiceImpl } from "./serviceImpl.ts";

export interface BrightyService {
    findBrightyChats(filters: BrightyFilters): Promise<BrightyMessagesResponseDTO>
    findBrightyChatById(id:string): Promise<FindBrightyChatByIdDTO>
    sendMessage(message: UserMessage): Promise<void>
    getTitle(thread_id?: string): Promise<string | getAllTitlesResponseDTO>
    deleteChat(thread_id: string): Promise<void>
}

export function NewBrightyService(): BrightyService {
    return new BrightyServiceImpl();
}